import { render, staticRenderFns } from "./PinnedMessages.vue?vue&type=template&id=0d76fe18&"
import script from "./PinnedMessages.vue?vue&type=script&lang=js&"
export * from "./PinnedMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports